import { Combobox } from "@adfenix/alexandria";
import { useRecoilValue } from "recoil";
import { useTranslation } from "react-i18next";
import useUserInfo from "hooks/useUserInfo";
import { userDomains } from "atoms/auth";
import { ConfigurationService } from "@adfenix/types";

interface ModalSelectHqProps {
  setSelectedHq: (selectedHq: ConfigurationService.HqAndDomainModel) => void;
  selectedHq?: ConfigurationService.HqAndDomainModel;
  disabled?: boolean;
  hqs?: ConfigurationService.HqAndDomainModel[];
}

export const SelectHqCombobox = ({
  selectedHq,
  setSelectedHq,
  disabled,
  hqs
}: ModalSelectHqProps) => {
  const { t } = useTranslation();
  const { accessLevel } = useUserInfo();

  const domains = useRecoilValue(userDomains);

  const sortedHqs = hqs
    ?.map(a => {
      const domainComponents = a.domain.split(".");
      const tld = domainComponents[domainComponents.length - 1];

      return {
        ...a,
        descriptiveName: a.descriptiveName
          ? `${a.descriptiveName} (${tld})`
          : a.domain
      };
    })
    .slice(0)
    .sort((a, b) => (a.descriptiveName < b.descriptiveName ? -1 : 1));

  const getFilteredHqs = () => {
    if (accessLevel !== "Multi-Brand") {
      return sortedHqs?.filter(hq => domains?.some(d => d === hq.domain)) ?? [];
    }

    return sortedHqs ?? [];
  };

  return (
    <>
      <Combobox
        items={getFilteredHqs()}
        valueObjectIndexAccessor="descriptiveName"
        isSearchable
        isClearable
        disabled={disabled}
        onChange={value =>
          setSelectedHq(hqs?.find(hq => hq.domain === value.domain) ?? value)
        }
        defaultItem={selectedHq}
        placeholder={t("listings.select.agency.modal.placeholder")}
        classNamePrefix="customer-hq-combobox"
      />
    </>
  );
};

export default SelectHqCombobox;
